import { useLanguage } from "../../context/LanguageContext";

const PurchaseProcessSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-20 md:py-28 bg-white" data-testid="purchase-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-[#B5613B] font-accent mb-4 block">{t.purchase.label}</span>
            <h2 className="font-heading text-3xl md:text-4xl text-[#2D2926] mb-8" data-testid="purchase-title">{t.purchase.title}</h2>
            <p className="text-[#6B6560] leading-relaxed mb-6">{t.purchase.p1}</p>
            <p className="text-[#6B6560] leading-relaxed">{t.purchase.p2}</p>
          </div>
          <div className="space-y-8 bg-[#FAF8F5] p-8 md:p-12">
            {t.purchase.steps.map((step, index) => (
              <div key={index} className="timeline-step-light" data-testid={`purchase-step-${index}`}>
                <div className="timeline-number-light">{index + 1}</div>
                <h4 className="font-heading text-lg text-[#2D2926] mb-2">{step.title}</h4>
                <p className="text-sm text-[#6B6560]">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PurchaseProcessSection;
